import FbService from 'FB';
import { api as Api } from 'utils';
import { helper } from 'utils';
import {
  appAuthToken,
  setTokenCode,
  removeStoredAuthToken,
  removeAppAuthToken,
  removeTokenCode,
  storeUser,
  removeStoredUser,
} from 'utils/auth';
import { currentGameConfig } from 'utils/handleCurrentContentConfig';

export const status = {
  error: 'E',
  success: 's',
};

export const internalAuth = async token => {
  try {
    const params = { lTn: token };
    const [{ internalAuth }, error] = await helper.asyncWrapper(() =>
      Api('POST', currentGameConfig.api.internalAuth, params),
    );

    if (error) throw error;

    const { plr } = internalAuth;
    appAuthToken(plr.lTn);
    storeUser(plr);

    return internalAuth;
  } catch (error) {
    console.error('Internal authentication failed:', error);
    removeStoredUser();
    removeStoredAuthToken();
    removeAppAuthToken();
    removeTokenCode();
    return null;
  }
};

export const storeUserLogin = async ({ fbUser, ton }) => {
  try {
    const params = { eUy: fbUser?.id, ton, aVn: Number(process.env.REACT_APP_VERSION) };
    const [{ login }, error] = await helper.asyncWrapper(() =>
      Api('POST', currentGameConfig.api.login, params),
    );
    if (error) throw error;
    const { plr } = login;
    const fullUserProfile = { ...fbUser, ...plr };
    appAuthToken(plr.lTn);
    storeUser(fullUserProfile);
    ton && setTokenCode(ton);
    return login;
  } catch (error) {
    removeStoredUser();
    removeStoredAuthToken();
    removeAppAuthToken();
    removeTokenCode();
  }
};

export const appUserLogin = async tokenCode => {
  return tokenCode ? await storeUserLogin({ ton: tokenCode }) : FbService.login();
};

export const getStoreData = async params => {
  const response = await Api('POST', currentGameConfig.api.store, params);
  const isValidResponse = 'ims' in response;
  const isValidStatus = isValidResponse && response.ims.sts === 's';
  if (!isValidStatus) {
    console.error('FAILED - invalid store data.', response);
    return null;
  }

  const storeData = response.ims.ims;

  const rootIZMp = storeData.iZMp;

  const isRootIZMpValid = rootIZMp && Object.keys(rootIZMp).length > 0;

  if (isRootIZMpValid) {
    const eventId = params.eId;
    if (storeData.evs && storeData.evs[eventId]) {
      storeData.evs[eventId].iZMp = rootIZMp;
    }
  }

  return storeData;
};

export const claimDynamicBonus = async params => {
  const { claimDynamicBonus } = await Api('POST', currentGameConfig.api.claimDynamicBonus, params);
  return claimDynamicBonus;
};

const appService = {
  internalAuth,
  storeUserLogin,
  appUserLogin,
  getStoreData,
  claimDynamicBonus,
};

export default appService;
